import React from 'react';
import { motion } from 'framer-motion';

const TeamMembersSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <div className="h-8 w-48 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-4 w-64 animate-pulse rounded-lg bg-slate-200"></div>
        </div>
        <div className="h-10 w-32 animate-pulse rounded-xl bg-slate-200"></div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: index * 0.1 }}
            className="rounded-xl border bg-white p-4"
          >
            <div className="flex items-center space-x-3">
              <div className="h-10 w-10 animate-pulse rounded-lg bg-slate-200 p-2"></div>
              <div className="space-y-2">
                <div className="h-3 w-16 animate-pulse rounded bg-slate-200"></div>
                <div className="h-6 w-8 animate-pulse rounded bg-slate-200"></div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="rounded-xl border bg-white p-4">
        <div className="flex flex-col gap-4 sm:flex-row">
          <div className="h-10 flex-1 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-10 w-32 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-10 w-24 animate-pulse rounded-lg bg-slate-200"></div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="rounded-xl border bg-white p-6"
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="h-10 w-10 animate-pulse rounded-full bg-slate-200 p-2"></div>
                <div className="space-y-2">
                  <div className="h-4 w-24 animate-pulse rounded bg-slate-200"></div>
                  <div className="h-3 w-20 animate-pulse rounded bg-slate-200"></div>
                </div>
              </div>
              <div className="flex space-x-1">
                <div className="h-6 w-6 animate-pulse rounded bg-slate-200"></div>
                <div className="h-6 w-6 animate-pulse rounded bg-slate-200"></div>
              </div>
            </div>

            <div className="mb-4 space-y-3">
              <div className="flex items-center justify-between">
                <div className="h-3 w-12 animate-pulse rounded bg-slate-200"></div>
                <div className="h-6 w-16 animate-pulse rounded-full bg-slate-200"></div>
              </div>
              <div className="flex items-center justify-between">
                <div className="h-3 w-10 animate-pulse rounded bg-slate-200"></div>
                <div className="h-3 w-24 animate-pulse rounded bg-slate-200"></div>
              </div>
              <div className="flex items-center justify-between">
                <div className="h-3 w-12 animate-pulse rounded bg-slate-200"></div>
                <div className="h-3 w-20 animate-pulse rounded bg-slate-200"></div>
              </div>
              <div className="flex items-center justify-between">
                <div className="h-3 w-8 animate-pulse rounded bg-slate-200"></div>
                <div className="h-5 w-16 animate-pulse rounded-full bg-slate-200"></div>
              </div>
            </div>

            <div className="flex space-x-2">
              <div className="h-8 flex-1 animate-pulse rounded-lg bg-slate-200"></div>
              <div className="h-8 flex-1 animate-pulse rounded-lg bg-slate-200"></div>
              <div className="h-8 w-8 animate-pulse rounded-lg bg-slate-200"></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export const TeamMembersListSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <div className="h-8 w-48 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-4 w-64 animate-pulse rounded-lg bg-slate-200"></div>
        </div>
        <div className="h-10 w-32 animate-pulse rounded-xl bg-slate-200"></div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: index * 0.1 }}
            className="rounded-xl border bg-white p-4"
          >
            <div className="flex items-center space-x-3">
              <div className="h-10 w-10 animate-pulse rounded-lg bg-slate-200 p-2"></div>
              <div className="space-y-2">
                <div className="h-3 w-16 animate-pulse rounded bg-slate-200"></div>
                <div className="h-6 w-8 animate-pulse rounded bg-slate-200"></div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="rounded-xl border bg-white p-4">
        <div className="flex flex-col gap-4 sm:flex-row">
          <div className="h-10 flex-1 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-10 w-32 animate-pulse rounded-lg bg-slate-200"></div>
          <div className="h-10 w-24 animate-pulse rounded-lg bg-slate-200"></div>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border bg-white">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b bg-slate-50">
              <tr>
                {[...Array(6)].map((_, index) => (
                  <th key={index} className="px-6 py-3">
                    <div className="h-3 w-16 animate-pulse rounded bg-slate-200"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {[...Array(5)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {[...Array(6)].map((_, cellIndex) => (
                    <td key={cellIndex} className="px-6 py-4">
                      <div className="space-y-2">
                        <div className="h-4 w-20 animate-pulse rounded bg-slate-200"></div>
                        {cellIndex === 0 && (
                          <div className="h-3 w-16 animate-pulse rounded bg-slate-200"></div>
                        )}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
        className={`rounded-full border-2 border-slate-300 border-t-blue-600 ${sizeClasses[size]}`}
      />
    </div>
  );
};
export const EmptyStateSkeleton = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center px-4 py-16"
    >
      <div className="mb-6 h-24 w-24 animate-pulse rounded-full bg-slate-200 p-6"></div>
      <div className="mb-2 h-6 w-48 animate-pulse rounded-lg bg-slate-200"></div>
      <div className="mb-6 h-4 w-64 animate-pulse rounded-lg bg-slate-200"></div>
      <div className="h-10 w-40 animate-pulse rounded-xl bg-slate-200"></div>
    </motion.div>
  );
};

export default TeamMembersSkeleton;
